import CategoryPage from './CategoryPage';

const ExtintoresPage = () => <CategoryPage category="extintores" />;

export default ExtintoresPage;
